var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-tab',{attrs:{"tabs":_vm.tabs,"icon":_vm.tabIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }